import ToggleSwitcher from './ToggleSwitcher';

export default ToggleSwitcher;
